import { copyCompaniesAdapter } from './reducer'

export const { selectAll: selectAllCopyCompanies } = copyCompaniesAdapter.getSelectors(
  state => state.copyCompanies
)
